import React, { useState, useRef } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Box, Button, Grid, TextField } from "@mui/material";
// import { addChecklist } from "../../../../services/campusrootTeam/index";
import Images from "../../assets";
import { addChecklist } from "../../services";
import { useAppDispatch,useAppSelector } from "../../assets/hooks";
import { closePopup } from "../../store/slices/popupSlice";
import Socket from "../../assets/socket";

interface InitialValues {
  name: string;
  desc: string;
  applicationId: string;
  uploaded_file: string;
  isChecked: string;
}

const Checklist = (props: any) => {
  const profile = useAppSelector((state) => state.profileInfo);
  const [file, setFile] = useState<File | undefined>();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const inputFile = useRef<HTMLInputElement | null>(null);
  const imageClick = () => {
    inputFile.current?.click();
  };

  const initialValues: InitialValues = {
    name: "",
    desc: "",
    applicationId: props.data.id,
    uploaded_file: "",
    isChecked: "",
  };

  const submit = async (values: InitialValues) => {
    setLoading(true);
    if (values || file !== undefined) {
      const formData = new FormData();
      formData.append("applicationId", values.applicationId);
      formData.append("uploaded_file", file || "");
      formData.append("name", values.name);
      formData.append("desc", values.desc);
      formData.append("isChecked", values.isChecked);
      try {
        const response = await addChecklist(formData);
        if (response) {
          props.data.setChecklist(response?.data?.data?.docChecklist);
          dispatch(closePopup());
          const triggerObject = {
            action: "ChecklistUpdatedProcessCoordinator",
            sender: profile.data,
            recievers: [response?.data.data.user],
            data: response.data.data,
          };
          Socket.emit("trigger", triggerObject);
        } else {
        }
      } catch (error) {}
    }
    setLoading(false);
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => submit(values)}
      >
        {({ values, handleChange }) => (
          <Form>
            <div>
              <div className="mb-5">
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", flexDirection: "column", mb: 1 }}
                  >
                    <label
                      htmlFor="name"
                      style={{ marginBottom: "0.3rem", fontWeight: "500" }}
                    >
                      Name
                    </label>
                    <TextField
                      name="name"
                      style={{ height: "2.5rem" }}
                      placeholder="Checklist name"
                      type="text"
                      required
                      size="small"
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="field-error"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <label
                      htmlFor="desc"
                      style={{ marginBottom: "0.3rem", fontWeight: "500" }}
                    >
                      Description
                    </label>
                    <TextField
                      required
                      name="desc"
                      placeholder="Add description"
                      type="text"
                      multiline
                      size="small"
                      onChange={handleChange}
                      value={values.desc}
                    />
                    <ErrorMessage
                      name="desc"
                      component="div"
                      className="field-error"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Field
                      name="isChecked"
                      placeholder="Add content"
                      type="checkbox"
                      style={{width:"1rem",height:"1rem"}}
                    />
                    <label
                      htmlFor="isChecked"
                      style={{
                        marginBottom: "0.3rem",
                        marginLeft: "0.5rem",
                        fontWeight: "500",
                      }}
                    >
                      Checked
                    </label>
                    <ErrorMessage
                      name="isChecked"
                      component="div"
                      className="field-error"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <div className="flex" style={{display:"flex"}}>
                      <label
                        htmlFor="uploaded_file"
                        style={{
                          marginBottom: "0.3rem",
                          marginRight: "0.8rem",
                          fontWeight: "500",
                        }}
                      >
                        Upload file
                      </label>
                      <input
                        style={{ display: "none" }}
                        type="file"
                        className=""
                        accept=".pdf"
                        name="uploaded_file"
                        onChange={(e) => setFile(e.target.files?.[0])}
                        ref={inputFile}
                      />
                      <FileUploadOutlinedIcon
                        onClick={() => imageClick()}
                        sx={[{ color: "#000" }]}
                      />
                      <h4>{file?.name}</h4>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
            <Box sx={{ textAlign: "center" }}>
              <Button
                type="submit"
                sx={{
                  color: "#fff",
                  background: "#3B3F76",
                  borderRadius: "5px",
                  textTransform: "none",
                  fontSize: "0.8rem",
                  "&:hover": {
                    background: "#3B3F76",
                  },
                }}
              >
                {loading ? (
                  <Box
                    component="img"
                    src={Images.standardLoader}
                    alt="standardLoader"
                    sx={{ width: "1rem", height: "1rem" }}
                  />
                ) : (
                  "Save"
                )}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Checklist;
